const isISOTimeString = (timeInISOFormat: string): boolean => {
  const date: Date = new Date(`${timeInISOFormat}Z`);
  return (
    !Number.isNaN(date.valueOf()) &&
    date.toISOString().slice(0, 19) === timeInISOFormat
  );
};

const isISODateString = (dateInISOFormat: string): boolean => {
  const date: Date = new Date(dateInISOFormat);
  return (
    !Number.isNaN(date.valueOf()) &&
    date.toISOString().slice(0, 10) === dateInISOFormat
  );
};

export { isISOTimeString, isISODateString };
